import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, Partners, Banner, Activities } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <WhyUs />
        <Activities />
        <Testimonials />
        <Team />
        <Banner />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;